// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactUpdateEffect from "./ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function makeTransition(animation, duration, timingFunction) {
  let duration$1 = String(duration / 1000) + "s";
  return {
    start: animation === "fadeBubbleTranslationFromBottom" ? "fadeBubbleTranslationFromBottom" : (
        animation === "fadePopinTranslation" ? "fadePopinTranslation" : (
            animation === "fadeBubbleTranslationFromLeft" ? "fadeBubbleTranslationFromLeft" : (
                animation === "fadeBubbleTranslation" ? "fadeBubbleTranslation" : (
                    animation === "fadeBubbleTranslationFromRight" ? "fadeBubbleTranslationFromRight" : (
                        animation === "fadeTranslation" ? "fadeTranslation" : "fadeIn"
                      )
                  )
              )
          )
      ),
    end: "fadeOut",
    duration: duration$1,
    timing: "cubic-bezier(.4, 0, .2, 1)"
  };
}

function AnimatedRender(props) {
  let transformOrigin = props.transformOrigin;
  let __timingFunction = props.timingFunction;
  let __duration = props.duration;
  let __animation = props.animation;
  let displayed = props.displayed;
  let animation = __animation !== undefined ? __animation : "fadeBubbleTranslation";
  let duration = __duration !== undefined ? __duration : 85;
  let timingFunction = __timingFunction !== undefined ? __timingFunction : "cubicBezier";
  let match = React.useState(() => displayed);
  let setShouldRender = match[1];
  ReactUpdateEffect.use1(() => {
    if (displayed) {
      setShouldRender(param => true);
    }
  }, [displayed]);
  let onAnimationEnd = param => {
    if (!displayed) {
      return setShouldRender(param => false);
    }
  };
  let match$1 = makeTransition(animation, duration, timingFunction);
  let style;
  if (displayed) {
    let tmp = {
      animationDuration: match$1.duration,
      animationName: match$1.start,
      animationTimingFunction: match$1.timing
    };
    if (transformOrigin !== undefined) {
      tmp.transformOrigin = transformOrigin;
    }
    style = tmp;
  } else {
    let tmp$1 = {
      animationDuration: match$1.duration,
      animationFillMode: "forwards",
      animationName: match$1.end,
      animationTimingFunction: match$1.timing
    };
    if (transformOrigin !== undefined) {
      tmp$1.transformOrigin = transformOrigin;
    }
    style = tmp$1;
  }
  if (match[0]) {
    return JsxRuntime.jsx("div", {
      children: props.children,
      style: style,
      onAnimationEnd: onAnimationEnd
    });
  } else {
    return null;
  }
}

let make = React.memo(AnimatedRender);

export {
  make,
}
/* make Not a pure module */
